import React, { PropsWithChildren, useContext } from "react";
import { styled, Box, Skeleton, SxProps } from "@mui/material";
import { Device } from "@services/devices/types";
import Footer from "./footer";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { getStatusLabel } from "./const";
import { getStatusSxColorFn } from "@common/components/ListDetailViews/DetailView/DeviceCard/const";

const CardContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.meeting.background}`,
  borderRadius: theme.radius.medium,
  backgroundColor: theme.palette.background.default,
  display: "flex",
  justifyContent: "space-between",
}));
const CardContainerPortrait = styled(CardContainer)(({ theme }) => ({
  flexDirection: "column",
}));

const CardContainerLandscape = styled(CardContainer)({
  flexDirection: "row",
});
const [HEIGHT_PORTRAIT, HEIGHT_LANDSCAPE] = ["40em", "20em"];

export const CardFooter = Footer;
export const CardHolder = ({
  device,
  children,
  landscape = false,
}: PropsWithChildren<{ device?: Device; landscape?: boolean }>) => {
  const { detail } = useContext(RoomsRealtimeContext);
  if (device === undefined)
    return (
      <Skeleton
        variant="rectangular"
        height={landscape ? HEIGHT_LANDSCAPE : HEIGHT_PORTRAIT}
        sx={(theme) => ({ borderRadius: theme.radius.medium })}
      />
    );
  const status = getStatusLabel(device, detail?.meeting)[0];
  const Container = landscape ? CardContainerLandscape : CardContainerPortrait;
  return (
    <Container sx={{ borderColor: getStatusSxColorFn(status) }}>
      {children}
    </Container>
  );
};
